export default __webpack_public_path__ + "static/media/o_wdt_c_3.dfcc90c0.mp3";